import * as Yup from 'yup';
import { EntityFormType } from '../interfaces/entity-form';
import { destinationNameValidator, sourceNameValidator } from '../validators/entityNameValidators';
import { useAsyncFieldTest } from '../../shared/components/AsyncValidationForm/hooks/useAsyncFieldTest';
import { TemplateFormState } from '../../template-form/interfaces/template-form';

export function useEntityFormValidations(
  entity: EntityFormType,
  initialSchema: Yup.ObjectSchema,
  initialValues: TemplateFormState,
  isFieldRendered: (fieldName: string) => boolean
) {
  const noun = entity === 'SOURCE' ? 'Source' : 'Destination';

  const dynamicSchemaFields = Object.keys(initialSchema.fields).reduce(
    (acc, fieldName: string) => {
      if (isFieldRendered(fieldName)) {
        acc[fieldName] = (initialSchema as Yup.ObjectSchema<{ [key: string]: unknown }>).fields[
          fieldName
        ];
      }
      return acc;
    },
    {} as Yup.ObjectSchema<{ [key: string]: unknown }>['fields']
  );

  const dynamicSchema = Yup.object().shape(dynamicSchemaFields);

  const entityNameTest = useAsyncFieldTest({
    fieldName: 'name',
    skipValidationOnStoredValue: true,
    storedValue: initialValues.name,
    isRequired: true,
    requiredMessage: `${noun} name is a required field`,
    validator: entity === 'SOURCE' ? sourceNameValidator : destinationNameValidator
  });

  return Yup.object()
    .concat(dynamicSchema)
    .shape({
      name: Yup.string().trim().test('entityFormNameFieldAsyncSchema', '', entityNameTest)
    });
}
